import React from "react";

export default function Notfound() {
  return (
    <div className="nf_container">
      <h1>404</h1>
      <h3>Essa página não existe.</h3>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Notfound/index.js